export default "__VITE_ASSET__Cu88FoHW__"